export default (number) => {
    return typeof number === "number";
};
